import {gql} from '@apollo/client';

const GET_PARTNERS = gql`
  query busPartners($countryIds: [ID]) {
    busPartners(queryParams: {countries: $countryIds}) {
      id
      name
      mobilityPartnerId
      countryId
      depots {
        city
        postCode
        street
      }
      currency
      source
      status
    }
  }
`;

export default GET_PARTNERS;
